import styled from '@emotion/styled';

import { createClassNames } from '@hrworks/design-system/functions';

import { S as ModalStyles } from '../Modal.styles';

const Footer = styled.div(({ theme }) => ({
  padding: ModalStyles.componentConfig(theme).contentPadding,
  borderTop: `1px solid ${theme.eclipseTier2Color.border.bold}`,
}));

const components = { Footer };

export const S = {
  ...components,
  ...createClassNames('ModalFooter', components),
} as const;
